module.exports = __webpack_public_path__ + "static/guilherme-1e55acba586f37a099b7a32eeeb33da5.jpg";